import { css } from 'styled-components';
export const thickenPrimaryShadow = ({ theme }) => css `
  box-shadow: 0 4px 30px 0 ${theme.themeVariables.frameDropShadow};
`;
//# sourceMappingURL=thickenPrimaryShadow.js.map